import { createUseStyles } from 'react-jss';
import { backgroundStatusBlue, iconLink } from '../../../theme';

export default createUseStyles(
  {
    root: {
      width: 60,
      height: 60,
      borderRadius: '50%',
      boxSizing: 'border-box',
      backgroundColor: backgroundStatusBlue,
      color: iconLink,
    },

    phone: {
      padding: [13, 20],
      ['@media (max-width: 768px)']: {
        width: 35,
        height: 35,
        padding: 4,
      },
    },

    email: {
      padding: [20, 16],
      ['@media (max-width: 768px)']: {
        width: 35,
        height: 35,
        padding: 6,
      },
    },
  },
  {
    name: 'CircleIcon',
  },
);
